import { IExtendedDiscountItem } from "../pages/Quotation/Components/AuthorizedDiscountComponent/AuthorizedDiscountComponent.types";

export function hasDuplicateKeys(
  arr: IExtendedDiscountItem[],
  key: keyof IExtendedDiscountItem
): boolean {
  const uniqueKeys: Set<string> = new Set();

  for (const obj of arr) {
    const objKey: any = obj[key];
    console.log('objKey:::', objKey);

    if (uniqueKeys.has(objKey)) {
      // Duplicate key found
      return true;
    }

    uniqueKeys.add(objKey);
  }

  // No duplicate keys found
  return false;
}
